import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import styles from '../ForInvestors.module.scss';
import Bind from 'lodash-decorators/bind';
import { DEFAULT_LIMIT as HOMEPAGE_ARTICLES_LIMIT } from 'views/Home/Sections/NewsAndEvents/NewsAndEvents';
import moment from 'moment';

import { LOAD_STATES, ANCHOR } from 'common/consts/common';
import { generateYearsFilterArray } from 'utils/date-utils';
import PrimaryButtonComponent from 'common/components/PrimaryButtonComponent/PrimaryButtonComponent';
import LanguageService from 'services/Language.service';
import NewsStore from 'stores/News.store';
import ConditionalLink from 'common/components/ConditionalLink/ConditionalLink';
import messages from '../ForInvestors.intl';

const DEFAULT_LIMIT = 4;
const DEFAULT_SKIP = 0;
const OLDEST_YEAR = 2017;

const ThumbnailNews = ({ item = {}, first }) => {
  const currentLanguage = LanguageService.getLang();
  const background = {
    background: 'grey',
    backgroundImage: `url('${item.photo}')`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <ConditionalLink
      className={first ? styles.NewsActualWrapper : styles.NewsThumbnailWrapper}
      condition={true}
      to={`${ANCHOR.NEWS[currentLanguage]}/${item.category}/${item.slug}`}
    >
      <div
        className={first ? styles.NewsActualImg : styles.NewsThumbnailImg}
        style={background}
      />
      <div className={styles.NewsTextWrapper}>
        <div
          className={first ? styles.NewsActualTitle : styles.NewsThumbnailTitle}
        >
          {item.title}
        </div>
        <div className={styles.NewsThumbnailDate}>
          {moment(item.publicationDate).format('LL')}
        </div>
      </div>
    </ConditionalLink>
  );
};

@injectIntl
@observer
export default class News extends Component {
  constructor(props) {
    super(props);
    this.initFetch = true;

    this.newsList = generateYearsFilterArray({
      first: {
        text: '',
        value: ''
      },
      from: OLDEST_YEAR
    })[0];

    if (!this.newsList) {
      return;
    }

    this.state = {
      activeFilter: this.newsList,
      loadState: LOAD_STATES.LOADED,
      latestNews: {
        criteria: {
          publishYear: this.newsList.value
        },
        pagination: {
          skip: DEFAULT_SKIP,
          limit: DEFAULT_LIMIT
        },
        items: [],
        endOfCollection: false
      }
    };
  }

  componentDidMount() {
    if (!this.newsList) {
      return;
    }
    this.fetchLatest();
  }

  componentWillUnmount() {
    if (!this.newsList) {
      return;
    }

    const { criteria, pagination, endOfCollection } = this.state.latestNews;
    NewsStore.latestNewsSettings = {
      criteria: { ...criteria },
      pagination: { ...pagination },
      endOfCollection: endOfCollection
    };
  }

  @Bind
  async fetchLatest() {
    this.setState({ loadState: LOAD_STATES.LOADING });

    const { criteria, pagination, items } = this.state.latestNews;
    const queriedLatestNews = await NewsStore.fetchLatestNews(
      criteria,
      pagination
    );

    const skipHomepageCachedArticles =
      NewsStore.initHomepageFetch.get() && this.initFetch
        ? HOMEPAGE_ARTICLES_LIMIT
        : DEFAULT_SKIP;

    // immmutable
    const newState = {
      criteria: { ...criteria },
      pagination: {
        limit: DEFAULT_LIMIT,
        skip: pagination.skip + pagination.limit + skipHomepageCachedArticles
      },
      items: [...items, ...queriedLatestNews.items],
      endOfCollection: queriedLatestNews.endOfCollection
    };

    this.setState({
      latestNews: newState,
      loadState: LOAD_STATES.LOADED
    });

    this.initFetch = false;
  }

  isLoaded() {
    return this.state.loadState === LOAD_STATES.LOADED;
  }

  render() {
    if (!this.newsList) {
      return null;
    }

    const {
      latestNews: { items, endOfCollection }
    } = this.state;

    const latestNews = [...items];
    const mostLatestNews = latestNews.shift();

    return (
      <div className={styles.News}>
        <h2 className={styles.Header}>
          {this.props.intl.formatMessage(messages.newsTitle)}
        </h2>
        <ThumbnailNews item={mostLatestNews} first />
        {latestNews.map(item => <ThumbnailNews key={item.id} item={item} />)}
        <div className={styles.ButtonWrapper}>
          {!endOfCollection && (
            <PrimaryButtonComponent
              onClick={this.fetchLatest}
              isBusy={!this.isLoaded()}
              text={this.props.intl.formatMessage(messages.newsButton)}
            />
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ForInvestors/components/News.js